interface PermissionList {
  quiz: string[];
  question: string[];
  pack: string[];
  user: string[];
  subs: string[];
  player: string[];
  reward: string[];
  guest: string[];
  paymentMode: string[];
}
export const permissionsElement: PermissionList = {
  quiz: [
    'canOnlyCreateQuiz',
    'canOnlyUpdateQuiz',
    'canOnlyDeleteQuiz',
    'canOnlyReadQuiz',
    'canOnlyCreateAndUpdateQuiz',
    'canOnlyCreateAndDeleteQuiz',
    'canOnlyUpdateAndDeleteQuiz',
    'canOnlyCreateUpdateAndDeleteQuiz',
    'canDoAllQuizExceptUpdatequiz',
    'canDoAllQuizExceptCreatequiz',
    'canOnlyUpdatequizAndReadquiz',
    'canDoAllQuiz',
    'canDoAllQuizExceptCreate',
    'canDoAllQuizExceptUpdate',
    'canDoAllQuizExceptDelete',
    'canDoAllQuizExceptRead',
    'canOnlyReadquestion',
    'root',
  ],
  question: [
    'canOnlyCreateQuestion',
    'canOnlyUpdateQuestion',
    'canOnlyDeleteQuestion',
    'canOnlyReadQuestion',
    'canOnlyCreateAndUpdateQuestion',
    'canOnlyCreateAndDeleteQuestion',
    'canOnlyCreateUpdateAndDeleteQuestion',
    'canOnlyDeletequestionAndReadquestion',
    'canDoAllQuestion',
    'canDoAllQuestionsExceptDeletequestion',
    'canDoAllQuestionsExceptCreatequestion',
    'canDoAllQuestionsExceptUpdatequestion',
    'canOnlyReadquestion',
    'root',
  ],
  pack: [
    'canOnlyCreatepack',
    'canOnlyUpdatepack',
    'canOnlyDeletepack',
    'canOnlyReadpack',
    'canDoAllPackExceptDeletepack',
    'canOnlyCreateAndUpdatepack',
    'canOnlyCreateAndUpdatePack',
    'canOnlyCreateAndDeletePack',
    'canOnlyUpdateAndDeletePack',
    'canOnlyCreateUpdateAndDeletePack',
    'canDoAllPack',
    'root',
  ],
  user: [
    'canOnlyCreateUser',
    'canOnlyUpdateUser',
    'canOnlyDeleteUser',
    'canOnlyReadUser',
    'canOnlyCreateAndUpdateUser',
    'canOnlyCreateAndDeleteUser',
    'canOnlyUpdateAndDeleteUser',
    'canOnlyCreateUpdateAndDeleteUser',
    'canDoAllUsers',
    'canDoAllUserExceptCreate',
    'canDoAllUserExceptUpdate',
    'canDoAllUserExceptDelete',
    'canDoAllUserExceptRead',
    'canOnlyReaduser',
    'root',
  ],
  player: [
    'canOnlyCreateplayer',
    'canOnlyUpdateplayer',
    'canOnlyDeleteplayer',
    'canOnlyReadplayer',
    'canOnlyCreateAndUpdatePlayer',
    'canOnlyCreateAndDeletePlayer',
    'canOnlyUpdateAndDeletePlayer',
    'canOnlyCreateUpdateAndDeletePlayer',
    'canDoAllPlayers',
    'canDoAllPlayerExceptCreate',
    'canDoAllPlayerExceptUpdate',
    'canDoAllPlayerExceptDelete',
    'canDoAllPlayerExceptRead',
    'canOnlyReadplayer',
    'root',
  ],
  reward: [
    'canOnlyCreateReward',
    'canOnlyUpdateReward',
    'canOnlyDeleteReward',
    'canOnlyReadReward',
    'canOnlyCreateAndUpdateReward',
    'canOnlyCreateAndDeleteReward',
    'canOnlyUpdateAndDeleteReward',
    'canOnlyCreateUpdateAndDeleteReward',
    'canDoAllReward',
    'canDoAllRewardExceptCreate',
    'canDoAllRewardExceptUpdate',
    'canDoAllRewardExceptDelete',
    'canDoAllRewardExceptRead',
    'canOnlyReadreward',
    'root',
  ],
  subs: ['root', 'canDoAllUsers'],
  paymentMode: ['root'],
  guest: ['guest'],
};
